import React, { useEffect } from 'react'
import { useState } from 'react'
import { Progress, Checkbox, Modal, Spin } from 'antd';
import { ReactComponent as ConnectionLink } from "../../assets/images/connection-link.svg"
import { ReactComponent as DisConnectionLink } from "../../assets/images/disconnected.svg"
import { useForm } from 'react-hook-form'
import { createApiClient } from '@oneblinktech-org/helios-base';
import { notification } from 'antd';

const apiUrl = process.env.REACT_APP_API_URL;
const { post, remove } = createApiClient({ apiUrl });

function ConnectionSteps({ connection, closeModal, connectedConnection, setModalWidth }) {
    const [step, setStep] = useState(STEPS.ONE)
    const { register, formState: { errors }, handleSubmit, getValues } = useForm({})
    const [infoModal, setInfoModal] = useState(false)
    const [isChecked, setChecked] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (connectedConnection)
            setStep(STEPS.CONNECTION)
        else
            setStep(STEPS.ONE)
        setModalWidth(502)
    }, [connection, connectedConnection])

    const onNotification = (description) => {
        notification.open({
            message: 'Alert!',
            description: description,
            onClick: () => {
            },
        });
    }

    async function onSaveChanges(data) {
        if (!connection.name) {
            onNotification('Connection type API is wrong!')
            return;
        }
        if (data) {
            await setLoading(true)
            const token = await localStorage.getItem('h-access_token')

            let createData = {
                'key': data.access_token,
                'type': connection.name,
            }

            post('/connections/connect', createData, {
                "Authorization": `Bearer ` + token
            }).then(result => {
                if (result)
                    setStep(STEPS.THREE)
                setLoading(false)
            }).catch(e => {
                errors.access_token = 'Something went wrong! Try again.'
                setLoading(false)
            })
        }
    }

    async function handleDisconnectConnection() {
        const token = await localStorage.getItem('h-access_token')
        await setLoading(true)
        remove('/connections/disconnect/' + connectedConnection?.id, {
            "Authorization": `Bearer ` + token
        }).then(result => {
            if (result)
                closeModal(true)
            setLoading(false)
        }).catch(e => {
            setLoading(false)
            notification.open({ message: e?.message, type: 'error' })
            throw e
        })
    }

    return (
        <div>
            <div className='step-modal' key={step} >
                <div className='step-content'>
                    {step === STEPS.DISCONNECT ?
                        <div className='step-header justify-content-center'>
                            <b className='label' >Disconnect</b>
                        </div>
                        :
                        <div className='step-header'>
                            <b className='label' >{'Connect'}</b>
                        </div>
                    }
                </div>
                {/* connect */}
                {step === STEPS.ONE &&
                    <div className='step-one' >
                        <span className='step-info-connect'>Please contact the Helios Support Team so we can help you get connected with CCC Secure Share.</span>
                        <div className='action'>
                            <div className='footer-btn'>
                                <button className='cancel' onClick={() => closeModal()} >Cancel</button>
                                <button className={`btn connect-support`} onClick={() => window.open('https://heliospro.io/contact', '_blank')}>Contact Support</button>
                            </div>
                        </div>
                    </div>
                }

                {step === STEPS.CONNECTION &&
                    <div className='d-flex flex-column' >
                        <span className='step-info'>CCC Secure Share is <span className='step-info green-text'>enabled</span>. You are receiving job updates automatically in Helios when you make an update in CCC One.</span>
                        <div className='d-flex flex-row mb-3 gap-1'>
                            <span className='step-info'>Your CCC One ID number is: </span>
                            <span className='current-number'>{connectedConnection?.key}</span>
                        </div>
                        <div className='action'>
                            <div className='footer-btn'>
                                <button className='cancel' onClick={() => closeModal()} >Close</button>
                                <button className='btn disconnect' onClick={() => {
                                    setStep(STEPS.DISCONNECT)
                                    setModalWidth(308)
                                }}>
                                    <DisConnectionLink />
                                    Disconnect
                                </button>
                            </div>
                        </div>
                    </div>
                }

                {step === STEPS.DISCONNECT &&
                    <div className='d-flex flex-column justify-content-center' >
                        <div className='are-you-sure'>
                            <label>Are you sure?</label>
                            <span>You will no longer receive automatic updates from CCC One.</span>
                        </div>
                        <div className='footer-btn'>
                            <button className='cancel' onClick={() => closeModal()} >Cancel</button>
                            {loading ?
                                <button className='btn disconnect disabled' type='submit'>
                                    <Spin size='small' spinning={true} />
                                </button>
                                :
                                <button className='btn disconnect' onClick={() => handleDisconnectConnection()}>
                                    <DisConnectionLink />
                                    Yes, Disconnect
                                </button>
                            }
                        </div>
                    </div>
                }
            </div>

            <Modal open={infoModal} footer={null} closable={false} width={502} centered>
                <div className='step-modal'>
                    <p className='step-info'>Log into CCC One and your ID number will be in the address bar as shown in this example:</p>
                    <img className='ccc-img' src={require('../../assets/images/CCC-one.png').default} alt='' />
                    <div className='d-flex flex-row gap-1 mb-3'>
                        <span className='dont-forget-dis'>Don't forget to activate the app in CCC One - </span>
                        <span className='dont-forget-dis instructions'>instructions</span>
                    </div>
                    <div className='footer-btn'>
                        <button className='btn connect' onClick={() => setInfoModal(false)} >Close</button>
                    </div>
                </div>
            </Modal>
        </div >
    )
}

export default ConnectionSteps

const STEPS = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    CONNECTION: 4,
    DISCONNECT: 5
}